import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import request from "../../utils/http";
import toaster from "../../utils/toaster";
import { Spinner } from "baseui/spinner";
import ActionHeader from "../../components/ActionHeader";
import ActionBar from "../../components/ActionBar";
import { Button } from "baseui/button";
import { Overflow } from "baseui/icon";
import { FormControl } from "baseui/form-control";
import Copy from "../../components/Copy";
import enums from "../../utils/enums";
import { GoAlert } from "react-icons/go";
import { BsFileEarmark } from "react-icons/bs";
import { DateTime } from "luxon";
import { Tag } from "baseui/tag";
import { StatefulPopover } from "baseui/popover";
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalButton,
} from "baseui/modal";
import { Notification } from "baseui/notification";
import { Textarea } from "baseui/textarea";
import { Checkbox } from "baseui/checkbox";
import { useNavigate } from "react-router";
import { FieldGrid } from "./FieldGrid";
import { Tab, Tabs } from "baseui/tabs-motion";
import { StyledTable, StyledHeadCell, StyledBodyCell } from "baseui/table-grid";
import { getDateString, getRelativeDateString } from "../../utils/date";
import CandidateIdentityDocument from "../../components/CandidateIdentityDocument";
import CandidateAddress from "../../components/CandidateAddress";

const Container = styled.div``;
const Section = styled.div``;
const WhiteContainer = styled.div`
	width: 10rem;
	backgound-color: white;
	display: grid;
`;
const StyledTableRow = styled.div`
	display: contents;
`;

const MOJActionBar = (props: any) => {
	const navigate = useNavigate();

	const [mojModalIsOpen, setMojModalIsOpen] = useState(false);
	const [mojModalSaving, setMojModalSaving] = useState(false);
	const [targetMojStatus, setTargetMojStatus] = useState(null as any);

	const [clearAll, setClearAll] = useState(false);
	const [clearIdentityDocument, setClearIdentityDocument] = useState(false);
	const [clearResidency, setClearResidency] = useState(false);

	const [note, setNote] = useState("");

	const openMojModal = (targetStatus: string) => {
		setClearAll(false);
		setClearIdentityDocument(false);
		setClearResidency(false);

		const mojStatus = enums.candidateMojStatus.find(
			(item: any) => item.key === targetStatus
		);
		setTargetMojStatus(mojStatus);

		setMojModalIsOpen(true);
	};

	const closeMojModal = () => {
		setMojModalIsOpen(false);
	};

	const applyMojStatus = async () => {
		if (!mojModalSaving) {
			if (targetMojStatus.noteRequired && note.length === 0) {
				toaster.error("Note is required");
			} else {
				setMojModalSaving(true);

				await request(
					"POST",
					`/api/admin/candidate-moj/update-status/${props.candidateId}`,
					{
						status: targetMojStatus.value,
						clearAll,
						clearIdentityDocument,
						clearResidency,
						note,
					},
					true,
					false
				);

				toaster.success("MOJ status updated");

				window.location.reload();
			}
		}
	};

	const viewCandidate = () => {
		navigate(`/candidate/${props.candidateId}`);
	};

	return (
		<>
			<Modal
				onClose={closeMojModal}
				closeable
				isOpen={mojModalIsOpen}
				animate
				autoFocus
			>
				{mojModalIsOpen ? (
					<>
						<ModalHeader>
							Set Status To &quot;{targetMojStatus.label}&quot;
						</ModalHeader>
						<ModalBody>
							<div>
								<FormControl label={"Internal note"}>
									<>
										<Textarea
											value={note}
											rows={2}
											onChange={(e: any) => {
												setNote(e.target.value);
											}}
										/>
									</>
								</FormControl>
							</div>
							{/*
							<div>
								<FormControl label={"File upload"}>
									<>
										<FileUploader />
									</>
								</FormControl>
							</div>*/}
							{targetMojStatus.special &&
								targetMojStatus.special.indexOf("optional-clear-all") > -1 && (
									<div>
										<FormControl
											label={""}
											caption={
												"This will clear the candidate's anwers to all MOJ related questions"
											}
										>
											<>
												<Checkbox
													checked={clearAll}
													onChange={(e: any) => setClearAll(e.target.checked)}
												>
													Clear all MOJ question details
												</Checkbox>
											</>
										</FormControl>
									</div>
								)}
							{targetMojStatus.special &&
								targetMojStatus.special.indexOf(
									"optional-clear-identity-document"
								) > -1 && (
									<div>
										<FormControl
											label={""}
											caption={
												"This will clear any details related to the candidate's Driver's License or Passport"
											}
										>
											<>
												<Checkbox
													checked={clearAll || clearIdentityDocument}
													disabled={clearAll}
													onChange={(e: any) =>
														setClearIdentityDocument(e.target.checked)
													}
												>
													Clear Identity Document details
												</Checkbox>
											</>
										</FormControl>
									</div>
								)}
							{targetMojStatus.special &&
								targetMojStatus.special.indexOf("optional-clear-residency") >
									-1 && (
									<div>
										<FormControl
											label={""}
											caption={
												"This will clear any details related to the candidate's Residency/Visa"
											}
										>
											<>
												<Checkbox
													checked={clearAll || clearResidency}
													disabled={clearAll}
													onChange={(e: any) =>
														setClearResidency(e.target.checked)
													}
												>
													Clear residency details
												</Checkbox>
											</>
										</FormControl>
									</div>
								)}
							{targetMojStatus.special &&
								targetMojStatus.special.indexOf("reminder-notify-candidate") >
									-1 && (
									<div>
										<Notification>
											Remember to notify the candidate about what actions to
											take to properly complete their application
										</Notification>
									</div>
								)}
						</ModalBody>
						<ModalFooter>
							<ModalButton kind="secondary" onClick={closeMojModal}>
								Cancel
							</ModalButton>
							<ModalButton isLoading={mojModalSaving} onClick={applyMojStatus}>
								Okay
							</ModalButton>
						</ModalFooter>
					</>
				) : (
					<></>
				)}
			</Modal>
			{props.mojStatus.value < 20 ? (
				<ActionBar>
					<Button
						key="sent"
						kind="secondary"
						onClick={() => {
							openMojModal("SentToMOJ");
						}}
					>
						Mark as Sent to MOJ
					</Button>
					<Button
						key="more-details"
						kind="secondary"
						onClick={() => {
							openMojModal("AwaitingCandidateDetail");
						}}
					>
						More Details Required
					</Button>
					<StatefulPopover
						content={
							<WhiteContainer>
								<Button
									key="reject"
									kind="tertiary"
									onClick={() => {
										openMojModal("MOJFail");
									}}
								>
									Mark as Fail
								</Button>
								<Button
									key="reject"
									kind="tertiary"
									onClick={() => {
										navigate(`/candidate-reallocate/${props.candidateId}`);
									}}
								>
									Reallocate
								</Button>
								<Button key="view" kind="tertiary" onClick={viewCandidate}>
									View Candidate
								</Button>
							</WhiteContainer>
						}
						placement={props.popoverPlacement ?? "topRight"}
					>
						<Button kind="secondary">
							<Overflow />
						</Button>
					</StatefulPopover>
				</ActionBar>
			) : (
				<ActionBar>
					<Button
						key="sent"
						kind="secondary"
						onClick={() => {
							openMojModal("MOJClean");
						}}
					>
						Mark as OK
					</Button>
					<Button
						key="more-details"
						kind="secondary"
						onClick={() => {
							openMojModal("MOJNote");
						}}
					>
						Mark with Note
					</Button>
					<Button
						key="reject"
						kind="secondary"
						onClick={() => {
							openMojModal("MOJFail");
						}}
					>
						Mark as Fail
					</Button>
					<StatefulPopover
						content={
							<WhiteContainer>
								<Button
									key="reject"
									kind="tertiary"
									onClick={() => {
										navigate(`/candidate-reallocate/${props.candidateId}`);
									}}
								>
									Reallocate
								</Button>
								<Button
									key="more-details"
									kind="tertiary"
									onClick={() => {
										openMojModal("AwaitingCandidateDetail");
									}}
								>
									More Details Required
								</Button>
								<Button key="view" kind="tertiary" onClick={viewCandidate}>
									View Candidate
								</Button>
							</WhiteContainer>
						}
						placement={props.popoverPlacement ?? "topRight"}
					>
						<Button kind="secondary">
							<Overflow />
						</Button>
					</StatefulPopover>
				</ActionBar>
			)}
		</>
	);
};

const Candidate = () => {
	const urlParams = useParams() as any;
	const [activeTab, setActiveTab] = React.useState<React.Key>(0);

	const [candidateId, setCandidateId] = useState("");
	const [fields, setFields] = useState(null as any);
	const [notes, setNotes] = useState([] as any);
	const [loaded, setLoaded] = useState(false);

	const [mojStatus, setMojStatus] = useState(null as any);
	const [identityDocumentType, setIdentityDocumentType] = useState(null as any);
	const [residencyStatusType, setResidencyStatusType] = useState(null as any);

	const updateUrlParams = async () => {
		setCandidateId(urlParams.candidateId);
	};

	const getCandidate = async () => {
		let result = await request(
			"GET",
			`/api/admin/candidate-moj/${candidateId}`,
			null,
			true,
			false
		);
		if (result.success && result.data?.fields) {
			setFields(result.data.fields);
			setNotes(result.data.notes);

			setMojStatus(
				enums.candidateMojStatus.find(
					(item: any) =>
						item.value === result.data.fields["CandidateMOJ.Status"]
				)
			);

			setIdentityDocumentType(
				enums.candidateIdentityDocumentType.find(
					(item: any) =>
						item.value === result.data.fields["CandidateIdentityDocument.Type"]
				)
			);

			setResidencyStatusType(
				enums.candidateResidencyStatus.find(
					(item: any) =>
						item.value ===
						result.data.fields["Candidate.CandidateResidencyStatus"]
				)
			);

			setLoaded(true);
		} else {
			toaster.error("Unable to access candidate");
		}
	};

	useEffect(() => {
		if (candidateId != "") {
			getCandidate();
		}
	}, [candidateId]);

	useEffect(() => {
		updateUrlParams();
	}, [urlParams, updateUrlParams]);

	return (
		<Container>
			{!loaded && (
				<div>
					<Spinner />
				</div>
			)}
			{loaded && fields && (
				<>
					<ActionHeader>
						<div>
							<h1>
								MOJ Check: {fields["Candidate.FirstName"]}{" "}
								{fields["Candidate.LastName"]}
							</h1>
							<br />
							{mojStatus && (
								<>
									<Tag
										closeable={false}
										kind={mojStatus.kind}
										variant={mojStatus.variant}
										overrides={{ Text: { style: { maxWidth: "" } } }}
									>
										{mojStatus.label}
									</Tag>{" "}
									at{" "}
									{DateTime.fromISO(fields["CandidateMOJ.StatusDate"], {
										zone: "utc",
									})
										.setZone("Pacific/Auckland")
										.toLocaleString(DateTime.DATETIME_MED)}{" "}
									<em>
										(
										{DateTime.fromISO(fields["CandidateMOJ.StatusDate"], {
											zone: "utc",
										})
											.setZone("Pacific/Auckland")
											.toRelative()}
										)
									</em>
								</>
							)}
						</div>

						<MOJActionBar
							candidateId={candidateId}
							popoverPlacement="bottomRight"
							mojStatus={mojStatus}
						/>
					</ActionHeader>

					<Tabs
						activeKey={activeTab}
						onChange={({ activeKey }) => setActiveTab(activeKey)}
					>
						<Tab title="Detail">
							<>
								<Section>
									<Container>
										<FieldGrid>
											<div>
												<FormControl label={"First name"}>
													<Copy>{fields["Candidate.FirstName"]}</Copy>
												</FormControl>
											</div>
											<div>
												<FormControl label={"Middle name(s)"}>
													<Copy>
														{fields["Candidate.FirstMiddleNamesName"]}
													</Copy>
												</FormControl>
											</div>
											<div>
												<FormControl label={"Last name"}>
													<Copy>{fields["Candidate.LastName"]}</Copy>
												</FormControl>
											</div>
											<div> </div>
											<div>
												<FormControl label={"Known by other names?"}>
													<div>
														{fields["CandidateMOJ.KnownByOtherNames"]
															? "Yes"
															: "No"}
														{fields["CandidateMOJ.OtherNamesKnownBy"] != null &&
															fields["CandidateMOJ.OtherNamesKnownBy"].length >
																0 && (
																<>
																	<ul>
																		{fields[
																			"CandidateMOJ.OtherNamesKnownBy"
																		].map((name: string) => {
																			return (
																				<li>
																					<Copy>{name}</Copy>
																				</li>
																			);
																		})}
																	</ul>
																</>
															)}
													</div>
												</FormControl>
											</div>
										</FieldGrid>
									</Container>
								</Section>
								<hr />
								<Section>
									<Container>
										<FieldGrid>
											<div>
												<FormControl label={"Date of birth"}>
													<>
														<Copy>
															{fields["Candidate.DateOfBirth"] && (
																<>
																	{DateTime.fromISO(
																		fields["Candidate.DateOfBirth"]
																	).toLocaleString(DateTime.DATE_FULL)}
																</>
															)}
														</Copy>
													</>
												</FormControl>
											</div>
											<div>
												<FormControl label={"Gender"}>
													<div>{fields["Candidate.Gender"]}</div>
												</FormControl>
											</div>
											<div>
												<FormControl label={"City of birth"}>
													<Copy>{fields["CandidateMOJ.PlaceOfBirthCity"]}</Copy>
												</FormControl>
											</div>
											<div>
												<FormControl label={"Country of birth"}>
													<Copy>
														{fields["CandidateMOJ.PlaceOfBirthCountry"]}
													</Copy>
												</FormControl>
											</div>
											<div>
												<FormControl label={"Ethnicity"}>
													<div>{fields["Candidate.Ethnicity"]}</div>
												</FormControl>
											</div>
										</FieldGrid>
									</Container>
								</Section>
								<hr />
								<CandidateIdentityDocument fields={fields} mode="moj" />
								<hr />

								{residencyStatusType && (
									<>
										<Section>
											<Container>
												{fields[
													"Candidate.CandidateResidencyStatus.ToString"
												] === "NZCitizen" ? (
													<h2>Candidate is a New Zealand Citizen</h2>
												) : fields[
														"Candidate.CandidateResidencyStatus.ToString"
												  ] === "PermanentResident" ? (
													<h2>Candidate is a New Zealand Permanent Resident</h2>
												) : (
													<>
														<h2>
															Residency Status: {residencyStatusType.label}
														</h2>
														<FieldGrid>
															<div>
																<FormControl label={"Expiry date"}>
																	<Copy
																		style={
																			DateTime.fromISO(
																				fields["Candidate.VisaExpiry"]
																			) < DateTime.now()
																				? { color: "red" }
																				: DateTime.now().plus({ months: 18 }) >
																				  DateTime.fromISO(
																						fields["Candidate.VisaExpiry"]
																				  )
																				? { color: "orange" }
																				: {}
																		}
																	>
																		{DateTime.fromISO(
																			fields["Candidate.VisaExpiry"]
																		).toLocaleString(DateTime.DATE_FULL)}
																	</Copy>
																</FormControl>
															</div>
															<div>
																<FormControl label={"Visa file"}>
																	<div>
																		{fields["Candidate.VisaFile"].contentType &&
																		fields[
																			"Candidate.VisaFile"
																		].contentType.startsWith("image/") ? (
																			<>
																				<a
																					href={
																						fields["Candidate.VisaFile"]
																							.privateUrl
																					}
																					target="_blank"
																					rel="noopener"
																					style={{
																						textDecoration: "none",
																					}}
																				>
																					<img
																						src={
																							fields["Candidate.VisaFile"]
																								.privateUrl
																						}
																					/>
																				</a>
																			</>
																		) : (
																			<>
																				<div>
																					<a
																						href={
																							fields["Candidate.VisaFile"]
																								.privateUrl
																						}
																						target="_blank"
																						rel="noopener"
																						style={{
																							textDecoration: "none",
																						}}
																					>
																						<BsFileEarmark />{" "}
																						<span>Download</span>{" "}
																					</a>
																				</div>
																			</>
																		)}
																	</div>
																</FormControl>
															</div>
														</FieldGrid>
													</>
												)}
											</Container>
										</Section>
										<hr />
									</>
								)}

								<Section>
									<Container>
										<h2>Addresses</h2>
										<FieldGrid>
											<div>
												<FormControl label={"Physical address"}>
													<CandidateAddress
														address={fields["Candidate.PhysicalAddress"]}
													/>
												</FormControl>
											</div>
											<div>
												<FormControl label={"Mailing address"}>
													<>
														{fields[
															"Candidate.PhysicalAddressSameAsMailing"
														] ? (
															<>Same as physical</>
														) : (
															<CandidateAddress
																address={fields["Candidate.MailingAddress"]}
															/>
														)}
													</>
												</FormControl>
											</div>
											<div>
												<FormControl label={"Addresses from the last 10 years"}>
													<ul>
														{fields["CandidateMOJ.AddressesLast10Years"] &&
															fields["CandidateMOJ.AddressesLast10Years"].map(
																(address: string) => {
																	return (
																		<li>
																			<Copy>{address}</Copy>
																			{address.indexOf(",") > -1 && (
																				<ul>
																					{address
																						.split(",")
																						.map((line: string) => {
																							return (
																								<>
																									<br />
																									<br />
																									<li>
																										<Copy>{line}</Copy>
																									</li>
																								</>
																							);
																						})}
																				</ul>
																			)}
																		</li>
																	);
																}
															)}
													</ul>
												</FormControl>
											</div>
										</FieldGrid>
									</Container>
								</Section>
								<hr />

								{fields["CandidateMOJ.HasGivenAuthorityToRelease"] && (
									<>
										<Section>
											<Container>
												<h2>Declarations</h2>
												<FieldGrid>
													<div>
														<FormControl
															label={
																"I confirm that I have no convictions in New Zealand or any other Country"
															}
														>
															<div>
																{fields["CandidateMOJ.HasNoPreviousConvictions"]
																	? "Yes"
																	: "No"}{" "}
																{!fields[
																	"CandidateMOJ.HasNoPreviousConvictions"
																] && <GoAlert />}
															</div>
														</FormControl>
													</div>
													<div>
														<FormControl
															label={
																"Have you had any previous convictions, including traffic offences?"
															}
														>
															<div>
																{fields["CandidateMOJ.HasPreviousConvictions"]
																	? "Yes"
																	: "No"}{" "}
																{fields[
																	"CandidateMOJ.HasPreviousConvictions"
																] && <GoAlert />}
																{fields[
																	"CandidateMOJ.HasPreviousConvictions"
																] && (
																	<>
																		<br />
																		<br />
																		<ul>
																			{fields[
																				"CandidateMOJ.PreviousConvictions"
																			].map((conviction: string) => {
																				return (
																					<li>
																						<Copy>{conviction}</Copy>
																					</li>
																				);
																			})}
																		</ul>
																	</>
																)}
															</div>
														</FormControl>
													</div>
													<div>
														<FormControl
															label={
																"Are there any charges against you yet to be heard?"
															}
														>
															<div>
																{fields[
																	"CandidateMOJ.HasChargesAwaitingHearing"
																]
																	? "Yes"
																	: "No"}{" "}
																{fields[
																	"CandidateMOJ.HasChargesAwaitingHearing"
																] && <GoAlert />}
															</div>
														</FormControl>
													</div>
													<div>
														<FormControl label={"Declaration accepted?"}>
															<div>
																{fields[
																	"CandidateMOJ.CompanyRightTerminateEmployment"
																]
																	? "Yes"
																	: "No"}
															</div>
														</FormControl>
													</div>													
													<div>
														<FormControl
															label={"Would you like a copy of the report?"}
														>
															<div>
																{fields[
																	"CandidateMOJ.HasRequestedCopyOfMOJCheck"
																]
																	? "Yes"
																	: "No"}
															</div>
														</FormControl>
													</div>
													<div>
														<FormControl label={"Declaration accepted?"}>
															<div>
																{fields[
																	"CandidateMOJ.HasGivenAuthorityToRelease"
																]
																	? "Yes"
																	: "No"}
															</div>
														</FormControl>
													</div>
												</FieldGrid>
											</Container>
										</Section>
										<hr />
									</>
								)}
							</>
						</Tab>
						<Tab title="Notes">
							<>
								<StyledTable role="grid" $gridTemplateColumns={"3fr 1fr 1fr"}>
									<StyledTableRow role="row">
										<StyledHeadCell>Note</StyledHeadCell>
										<StyledHeadCell>Name</StyledHeadCell>
										<StyledHeadCell>Date</StyledHeadCell>
									</StyledTableRow>
									{notes &&
										notes.map((note: any, i: number) => {
											const striped = i % 2 === 0;

											return (
												<StyledTableRow role="row">
													<StyledBodyCell $striped={striped}>
														{note.note.indexOf("\n") > -1 ? (
															<>
																{note.note
																	.split("\n")
																	.map((noteLine: string) => {
																		return <p>{noteLine}</p>;
																	})}
															</>
														) : (
															<p>{note.note}</p>
														)}
													</StyledBodyCell>
													<StyledBodyCell $striped={striped}>
														<p>{note.createdBy}</p>
													</StyledBodyCell>
													<StyledBodyCell $striped={striped}>
														<p>
															{getDateString(note.createdUtc)} <br />
															<em>
																({getRelativeDateString(note.createdUtc)})
															</em>
														</p>
													</StyledBodyCell>
												</StyledTableRow>
											);
										})}
								</StyledTable>
							</>
						</Tab>
					</Tabs>

					<MOJActionBar
						candidateId={candidateId}
						popoverPlacement="bottomRight"
						mojStatus={mojStatus}
					/>

					{/*}
								<div>
									<FormControl label={""}>
										<div>{fields["Candidate."]}</div>
									</FormControl>
								</div>

								<div>
									<FormControl label={""}>
										<Copy>{fields["Candidate."]}</Copy>
									</FormControl>
								</div>

															*/}
				</>
			)}
		</Container>
	);
};
export default Candidate;
